import {
  call, put, takeLatest, all
} from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch.js';
import { actionCreators, actions } from 'react/api/actions/photoAlbum';
import globalErrorHandler from 'react/api/GlobalErrorHandler.js';

export function* selectPhotoInAlbumSaga(action) {
  yield put(actionCreators.setLoading(true));
  const { payload } = action;
  const { albumId } = payload;

  if (albumId) {
    const url = `PhotoAlbum/${albumId}/ListPhotos?thumbnailSize=SMALL`;
    const data = yield call(defaultFetch, url);
    const { error } = data;

    if (error) {
      yield globalErrorHandler(error);
    } else {
      const { photos = [] } = data;
      if (photos.length > 0) {
        yield put(actionCreators.addAllPhotosToAlbum(photos, albumId));
      }
    }
  }
  yield put(actionCreators.setLoading(false));
}

export function* selectPhotoInMultipleAlbumsSaga({ payload: albumIds }) {
  yield put(actionCreators.setLoading(true));
  try {
    const results = yield all(
      albumIds.map((albumId) => call(
        defaultFetch,
        `PhotoAlbum/${albumId}/ListPhotos?thumbnailSize=SMALL`
      ))
    );

    const formattedData = results.reduce((acc, result, index) => {
      const albumId = albumIds[index];
      if (result?.photos?.length > 0) {
        acc.push({ [albumId]: result.photos });
      } else {
        console.error(
          `Error fetching photos for albumId ${albumId}:`,
          result.reason
        );
      }
      return acc;
    }, []);

    yield put(actionCreators.addAllPhotosAlbums(formattedData));
  } catch (error) {
    yield globalErrorHandler(error);
  } finally {
    yield put(actionCreators.setLoading(false));
  }
}

export default function* photoAlbumSaga() {
  yield takeLatest(actions.selectAlbum, selectPhotoInAlbumSaga);
  yield takeLatest(
    actions.selectMultipleAlbums,
    selectPhotoInMultipleAlbumsSaga
  );
}
